import Plugin from "@ckeditor/ckeditor5-core/src/plugin";

export default class CommentUI extends Plugin {
  init() {
    
  }
}
